exports = module.exports = require("../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".box[data-v-5d5fb3a8]{z-index:999999}", "", {"version":3,"sources":["/./src/components/common/versionReminder.vue"],"names":[],"mappings":"AACA,sBACI,cAAe,CAClB","file":"versionReminder.vue","sourcesContent":["\n.box[data-v-5d5fb3a8]{\n    z-index: 999999\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.25.0@css-loader?sourceMap!./~/_vue-loader@9.9.5@vue-loader/lib/style-rewriter.js?id=data-v-5d5fb3a8&scoped=true!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/versionReminder.vue
// module id = 212
// module chunks = 0